import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { BenefitTh, BenefitTr, BenefitTd } from '../BenefitTable';
import {
  Content,
  withContext,
} from '../../../../components';
import { CONTENT_TYPE_FAST } from '../../../../components/Content';
import { Consumer } from '../../Context';

function BenefitMarkup(props) {
  const {
    context: {
      categoryBenefits,
      editAllowed,
      editBenefitName,
      onStartEdit,
      onSaveEdit,
      onCancelEdit,
      width,
      categoryName,
      enableReorder,
      onAddBenefit,
      addBenefit,
      editBenefitValue,
    },
  } = props;
  const nameColumnWidth = width === '100%' ? 30 : 50; // Percentage
  const subcategories = [...new Set(categoryBenefits.map(b => b.subcategory))];
  const subcategoryColumnWidth = (100 - nameColumnWidth) / subcategories.length;
  const benefitNames = [...new Set(categoryBenefits.map(b => b.name))];
  const benefitRows = benefitNames.map((benefitName, index) => {
    const benefitsWithName = categoryBenefits.filter(b => b.name === benefitName);
    const benefitCells = subcategories.map((subcategory) => {
      const benefit = benefitsWithName
        .find(b => b.subcategory === subcategory && b.id !== undefined);
      if (!benefit) {
        // if a benefit doesn't have a subcategory,
        // this provides the ability to add a new benefit for that subcategory.
        const allowedEditMode = editAllowed
          && !!addBenefit
          && (categoryName === addBenefit.category)
          && (subcategory === addBenefit.subCategoryName)
          && (benefitName === addBenefit.planBenefitName);
        return (
          <BenefitTd
            key={subcategory}
            editAvailable={editAllowed && !allowedEditMode}
            onClick={allowedEditMode ? null
              : event => onStartEdit(
                event,
                undefined,
                {
                  category: categoryName,
                  subCategoryName: subcategory,
                  planBenefitName: benefitName,
                },
              )}
            name="addBenefit"
            value=""
          >
            <Content
              edit={allowedEditMode}
              inherit
              onSave={onAddBenefit}
              onCancel={onCancelEdit}
              type={CONTENT_TYPE_FAST.PLAIN}
              value=""
            />
          </BenefitTd>
        );
      }
      const editMode = editAllowed && editBenefitValue && editBenefitValue.BenefitId === benefit.id;
      return (
        <BenefitTd
          key={subcategory}
          editAvailable={editAllowed && !editMode}
          onClick={editMode === true ? null : onStartEdit}
          value={benefit.id}
          name="editBenefitValue"
          columnWidth={`${subcategoryColumnWidth}%`}
        >
          <Content
            edit={editMode}
            inherit
            onSave={onSaveEdit}
            onCancel={onCancelEdit}
            type={CONTENT_TYPE_FAST.PLAIN}
            value={benefit.value}
          />
        </BenefitTd>
      );
    });
    const benefitNameEditMode = editAllowed
                                && editBenefitName
                                && editBenefitName.value === benefitName
                                && editBenefitName.categoryName === categoryName;
    return (
      <Draggable
        key={benefitName}
        draggableId={`draggableBenefitRow-${categoryName}-${benefitName}`}
        index={index}
        class={categoryName}
        isDragDisabled={!editAllowed || !enableReorder}
      >
        {(provided, snapshot) => (
          <BenefitTr
            key={benefitName}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
          >
            <BenefitTh
              scope="row"
              onClick={benefitNameEditMode === true
                ? null
                : event => onStartEdit(event, categoryName)}
              editAvailable={editAllowed && !benefitNameEditMode}
              name="editBenefitName"
              value={benefitName}
              columnWidth={`${nameColumnWidth}%`}
              isDragging={snapshot.isDragging}
            >
              <Content
                edit={benefitNameEditMode}
                inherit
                onSave={value => onSaveEdit(value, categoryName)}
                onCancel={onCancelEdit}
                type={CONTENT_TYPE_FAST.PLAIN}
                value={benefitName}
              />
            </BenefitTh>
            {benefitCells}
          </BenefitTr>
        )}
      </Draggable>
    );
  });
  return benefitRows;
}
export default withContext(Consumer)(BenefitMarkup);
